import type { AccessConstraint } from '@sb/shared/access';
import { featureFlag } from '@sb/shared/feature';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the communications routes. */
export const communicationsAccess = {
  'chat/opt-in': {
    subscriptionPlan: PlanType.BASIC,
    subscriptionPlanRedirect: '/communications/news',
    featureFlag: featureFlag.TMP_CHAT_MODULE_OPT_IN_ELIGIBILITY,
    featureFlagRedirect: '/communications/news',
  },
  chat: {
    subscriptionPlan: PlanType.BASIC,
    subscriptionPlanRedirect: '/communications/news',
    featureFlag: featureFlag.TMP_STREAM_CHAT,
    featureFlagRedirect: '/communications/news',
  },
  files: { subscriptionPlan: PlanType.BASIC },
} satisfies Record<string, AccessConstraint>;
